var m = require('mithril');
var buttonElement = require('./button');

function hasClippingAncestor(element) {
  if (!element || typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') return false;

  var current = element.parentElement;
  while (current && current !== document.body) {
    var style = window.getComputedStyle(current);
    var overflow = [style.overflow, style.overflowX, style.overflowY].join(' ');
    if (/(auto|hidden|scroll|clip)/.test(overflow)) {
      return true;
    }
    current = current.parentElement;
  }

  return false;
}

function getTriggerRect(element) {
  if (!element || typeof element.getBoundingClientRect !== 'function') return null;

  var visualElement = element.firstElementChild || element;
  if (visualElement && typeof visualElement.getBoundingClientRect === 'function') {
    return visualElement.getBoundingClientRect();
  }

  return element.getBoundingClientRect();
}

module.exports = {
  oninit: function (vnode) {
    vnode.state.open = false;
    vnode.state.lastCloseSignal = vnode.attrs.closeSignal;
    vnode.state.positionHoverBridge = function (bridgeElement) {
      var triggerRect = getTriggerRect(vnode.state.triggerElement);
      var menuElement = vnode.state.menuElement || (bridgeElement && bridgeElement.previousElementSibling);
      var menuRect = menuElement && typeof menuElement.getBoundingClientRect === 'function'
        ? menuElement.getBoundingClientRect()
        : null;

      if (!bridgeElement || !triggerRect || !menuRect) return;

      var bridgeLeft;
      var bridgeWidth;
      if (menuRect.left < triggerRect.left) {
        bridgeLeft = menuRect.left;
        bridgeWidth = triggerRect.left - menuRect.left;
      } else if (menuRect.right > triggerRect.right) {
        bridgeLeft = triggerRect.right;
        bridgeWidth = menuRect.right - triggerRect.right;
      } else {
        bridgeElement.style.display = 'none';
        return;
      }

      var bridgeHeight = menuRect.top - triggerRect.top;
      if (bridgeWidth <= 0 || bridgeHeight <= 0) {
        bridgeElement.style.display = 'none';
        return;
      }

      bridgeElement.style.display = 'block';
      bridgeElement.style.left = bridgeLeft + 'px';
      bridgeElement.style.top = triggerRect.top + 'px';
      bridgeElement.style.width = bridgeWidth + 'px';
      bridgeElement.style.height = bridgeHeight + 'px';
    };
  },

  view: function (vnode) {
    var ctrl = this;
    if (vnode.attrs.closeSignal !== undefined && vnode.attrs.closeSignal !== vnode.state.lastCloseSignal) {
      ctrl.open = false;
      vnode.state.lastCloseSignal = vnode.attrs.closeSignal;
    }

    var items = (vnode.attrs.items || []).filter(function (item) { return !!item; });
    var alignClass = vnode.attrs.align === 'left' ? 'left-0' : 'right-0';
    var fixed = vnode.attrs.position === 'fixed' ||
      (vnode.attrs.position !== 'absolute' && (ctrl.open || hasClippingAncestor(vnode.state.triggerElement)));
    var dropdownStyle = fixed
      ? { position: 'fixed', zIndex: 1000 }
      : { top: '100%', minWidth: '100%' };
    var arrowLabel = m('span.dib', {
      style: {
        width: 0,
        height: 0,
        borderLeft: '0.34rem solid transparent',
        borderRight: '0.34rem solid transparent',
        borderTop: '0.44rem solid #58abe2',
        verticalAlign: 'middle'
      }
    });
    var triggerLabel = vnode.attrs.triggerLabel ?
      m('span.flex.items-center', [
        m('span.mr2', vnode.attrs.triggerLabel),
        arrowLabel
      ])
      : vnode.attrs.label || arrowLabel;

    if (fixed && vnode.state.triggerElement && typeof window !== 'undefined') {
      var rect = getTriggerRect(vnode.state.triggerElement);
      if (rect) {
        dropdownStyle.top = rect.bottom + 'px';
        dropdownStyle.minWidth = rect.width + 'px';
        if (vnode.attrs.align === 'left') {
          dropdownStyle.left = rect.left + 'px';
        } else {
          dropdownStyle.left = rect.right + 'px';
          dropdownStyle.right = 'auto';
          dropdownStyle.transform = 'translateX(-100%)';
        }
      } else if (vnode.attrs.align === 'left') {
        dropdownStyle.left = '0';
      } else {
        dropdownStyle.right = '0';
      }
    } else if (vnode.attrs.align === 'left') {
      dropdownStyle.left = '0';
    } else {
      dropdownStyle.right = '0';
    }

    return m('div.relative.dib.row-action-dropdown', {
      onmouseleave: function () {
        ctrl.open = false;
      }
    }, [
      m('span.dib', {
        oncreate: function (innerVnode) {
          vnode.state.triggerElement = innerVnode.dom;
        },
        onupdate: function (innerVnode) {
          vnode.state.triggerElement = innerVnode.dom;
        }
      }, [
        m(buttonElement, {
          class: vnode.attrs.buttonClass || 'dib',
          style: vnode.attrs.buttonStyle || {
            minWidth: '2.1rem',
            paddingTop: '0.05rem',
            paddingBottom: '0.12rem',
            paddingLeft: '0.3rem',
            paddingRight: '0.3rem',
            lineHeight: '1'
          },
          label: triggerLabel,
          showFeedback: false,
          func: function (evt) {
            if (evt && typeof evt.stopPropagation === 'function') evt.stopPropagation();
            ctrl.open = !ctrl.open;
            if (ctrl.open && typeof vnode.attrs.onOpen === 'function') {
              vnode.attrs.onOpen(evt);
            }
          }
        })
      ]),
      m('div.br2.ba.pa2.bg-dark-gray.absolute.z-3.' + alignClass, {
        class: ctrl.open ? '' : 'dn',
        style: dropdownStyle,
        oncreate: function (menuVnode) {
          vnode.state.menuElement = menuVnode.dom;
        },
        onupdate: function (menuVnode) {
          vnode.state.menuElement = menuVnode.dom;
        },
        onmouseenter: function () {
          ctrl.open = true;
        }
      }, items.map(function (item, idx) {
        var itemClass = item.class || 'blue';
        if (idx < items.length - 1) itemClass += ' bb';

        return m('a.dim.f4.pa2.h-100.flex.items-center', {
          class: itemClass,
          href: item.href,
          onclick: function (evt) {
            if (evt && typeof evt.stopPropagation === 'function') evt.stopPropagation();
            ctrl.open = false;
            if (typeof item.onclick === 'function') {
              item.onclick(evt);
            }
          }
        }, [
          item.icon ? m('i', { class: 'f3 mr2 ' + item.icon }) : '',
          m('span.nowrap', item.label)
        ]);
      })),
      ctrl.open ? m('div.row-action-dropdown-hover-bridge', {
        'aria-hidden': 'true',
        style: {
          position: 'fixed',
          display: 'none',
          backgroundColor: 'transparent',
          pointerEvents: 'auto',
          zIndex: 999
        },
        oncreate: function (bridgeVnode) {
          vnode.state.positionHoverBridge(bridgeVnode.dom);
        },
        onupdate: function (bridgeVnode) {
          vnode.state.positionHoverBridge(bridgeVnode.dom);
        }
      }) : null
    ]);
  }
};
